<app-filter-panel [numberOfResults]="numberOfResults" [activeFilterCount]="activeFilterCount"
  (apply)="onApply()" (cancel)="onCancel()">

  <!-- Asset Types -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let item of assetTypes">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + item.name">
            <input type="checkbox" [id]="'checkbox-' + item.name"
              [checked]="isIn(draftAssetTypes, item.value!)"
              (change)="draftAssetTypes = toggleGuid(draftAssetTypes, item)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + item.name">{{ item.name }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Servic Types -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICESETUP_SERVICETYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let item of serviceTypes">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + item.name">
            <input type="checkbox" [id]="'checkbox-' + item.name"
              [checked]="isIn(draftServiceTypes, item.value!)"
              (change)="draftServiceTypes = toggleGuid(draftServiceTypes, item)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + item.name">{{ item.name }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Online Status -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "COMMUNICATIONSTATUS" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let status of meterStatuses">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-online-' + status">
            <input type="checkbox" [id]="'checkbox-online-' + status"
              [checked]="draftMeterStatus == status"
              (change)="onMeterStatusChange(status)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-online-' + status">{{ status.toUpperCase() | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Sim Status -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "SIMSTATUS" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let status of meterStatuses">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-sim-' + status">
            <input type="checkbox" [id]="'checkbox-sim-' + status"
              [checked]="draftSimStatus == status"
              (change)="onSimStatusChange(status)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-sim-' + status">{{ status.toUpperCase() | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Last Communication -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICES_LASTONLINETIME" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let period of lastCommunicationPeriods">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-lastcomm-' + period">
            <input type="checkbox" [id]="'checkbox-lastcomm-' + period"
              [checked]="draftLastCommunication == period"
              (change)="onLastCommunicationChange(period)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-lastcomm-' + period">{{ period.toUpperCase() | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Configuration Status -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "SIDEBAR_DEVICE" | translate }} {{ "CONFIGURATION" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let status of configurationStatuses">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-status-' + status">
            <input type="checkbox" [id]="'checkbox-status-' + status"
              [checked]="isIn(draftStatuses, status)"
              (change)="draftStatuses = toggle(draftStatuses, status)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-status-' + status">{{ status.toUpperCase() | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Meter Make -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "METERMAKE" | translate }}</span>
    </div>
    <div class="col-md-12">
      <app-multi-select-dropdown-search
        [selected]="draftMeterMakes"
        [fetchItems]="fetchMeterMakes"
        placeholder="SEARCHBY_METERMAKE"
        (listEmitted)="onMeterMakeListReceived($event)">
      </app-multi-select-dropdown-search>
    </div>
  </div>

  <!-- Meter Model -->
  <div class="row g-0 m-0">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICESETUP_METERMODEL" | translate }}</span>
    </div>
    <div class="col-md-12">
      <app-multi-select-dropdown-search
        [selected]="draftMeterModels"
        [fetchItems]="fetchMeterModels"
        placeholder="SEARCHBY_METERMODEL"
        (listEmitted)="onMeterModelListReceived($event)">
      </app-multi-select-dropdown-search>
    </div>
  </div>

  <!-- Area-->
  <div class="row g-0 m-0">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICESETUP_AREA" | translate }}</span>
    </div>
    <div class="col-md-12">
      <app-multi-select-dropdown-search
        [selected]="draftAreas"
        [fetchItems]="fetchAreas"
        placeholder="AREA_SEARCHBY"
        (listEmitted)="onAreaListReceived($event)">
      </app-multi-select-dropdown-search>
    </div>
  </div>

  <!-- Area-->
  <div class="row g-0 m-0">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "REGION" | translate }}</span>
    </div>
    <div class="col-md-12">
      <app-multi-select-dropdown-search
        [selected]="draftRegions"
        [fetchItems]="fetchRegions"
        placeholder="REGION_SEARCHBY"
        (listEmitted)="onRegionListReceived($event)">
      </app-multi-select-dropdown-search>
    </div>
  </div>

</app-filter-panel>
